import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import HelpSection from '../Quoters/Common/Appointment/HelpSection';
import { Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { TextInput, RadioInput } from '../Helpers/Inputs';
import States from '../Helpers/Lists/States'
import './Schedule.scss';
import { InputMaskPhone } from "../Helpers/Formatters";
import { object, string } from 'yup';
import Scheduler from '../Quoters/Common/Appointment/Scheduler';
import { emptyStringToUndefined } from '../Helpers/Formatters/EmptyStringToUndefined.js';
import BackNext from '../Quoters/Common/SubComponents/BackNext';
import BusinessHours from '../Quoters/Common/Appointment/BusinessHours';
import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_POLICY_REVIEW, SESSION_STORAGE_ACCOUNT_KEY, getBasicInfo } from '../../sessionStorage';
import Age from '../Helpers/Dates/Age';
import { HeaderStepper } from '../Quoters/Common/HeaderStepper/HeaderStepper';
import { createTheme, ThemeProvider, makeStyles } from '@material-ui/core';
import InputTheme from '../Quoters/Common/Helpers/InputTheme';
import { customValidators } from '../Helpers/Validators/customValidators';

export default function Schedule(props) {

  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: Schedule.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const formStateFromSession = getSessionStorageItem(SESSION_STORAGE_POLICY_REVIEW);
  const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account;
  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill');
  const [formState, setFormState] = useState(Schedule.DefaultFormState(prefill));
  const [loading, setLoading] = useState(false);

  let basicInfo = getBasicInfo();

  const handleValueChange = (field, value) => {
    setValue(field, value);
    setFormState({ ...formState, [field]: value });
  };

  const toBeReviewedText = () => {
    if (!formStateFromSession) {
      return '0';
    }
    const count = formStateFromSession.termPolicies.length + formStateFromSession.permPolicies.length;

    return `${count} ${count > 1 ? 'policies' : 'policy'} to be reviewed`;
  }

  const age = () => {
    if (!basicInfo) {
      return null;
    }

    return `${Age(basicInfo.birthdate)} years old`;
  }

  const fullState = () => {
    if (!basicInfo) {
      return "";
    }
    return States().find(s => s.value === basicInfo.state).label;
  }

  const onSubmit = () => {
    setLoading(true);

    setSessionStorageItem(SESSION_STORAGE_POLICY_REVIEW, { ...formStateFromSession, schedule: formState });

    var body = {
      'consumerAccountId': account.accountId,
      'oneClickAccountId': account.oneClickAccountId,
      'dob': basicInfo.birthdate,
      'firstname': formState.firstName,
      'lastname': formState.lastName,
      'gender': basicInfo.gender,
      'state': basicInfo.state,
      'phone': formState.phone,
      'email': formState.email,
      'timeZone': formState.timeZone,
      'specificappointmentutc': formState.specificAppt === 'schedule' ? formState.specificApptTime : null,
      'policyReview': formStateFromSession,
      'isPolicyReview': true,
    }

    fetch(`api/Case/PostApp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(body),
    })
      .then(response => response.json())
      .then((data) => {
        if (data.success) {
          props.history.push('/policy-review/summary');
        }
        else {
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
      })



  }

  const useStyles = makeStyles(theme => ({
    stepContainer: {
      backgroundColor: '#f9f9f9',
      border: '1px solid #e2e2e2',
      borderRadius: '0 0 4px 4px',
      paddingTop: '48px',
      marginTop: '-48px',
    },
    formSectionTitle: {
      color: '#333333',
      fontWeight: '700',
      fontSize: '14px',
    },
    addButton: {
      color: '#1C3D6C',
      fontWeight: '700',
      fontSize: '14px',
    },
    lightBackground: {
      backgroundColor: `${theme.palette.primary.main}16`,
    },
  }));
  const classes = useStyles();

  return (
    <HeaderStepper
      title="Schedule Your Policy Review"
      stepName='Schedule'
      step={3}
      totalSteps={3}
      hideContact={true}
    >
      <Container className={`${classes.stepContainer} schedule-container`}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="lgaModalInputs">

            <Col lg={6} >
              <div className='mx-5 mt-0 appointment-class py-3 px-5'>
                <h3 className="text-center title">Appointment Summary</h3>
                <h5 className="text-center subtitle mb-3">Policy Review</h5>
                <p className='bold-text'>Number of Policies</p>
                <p className='answer-text'>{toBeReviewedText()}</p>
                <Row>
                  <Col xs={6}>
                    <p className='bold-text'>Gender</p>
                    <p className='answer-text'>{(basicInfo && basicInfo.gender) && basicInfo.gender === 'M' ? 'Male' : 'Female'}</p>

                  </Col>
                  <Col xs={6}>
                    <p className='bold-text'>Age</p>
                    <p className='answer-text'>{age()}</p>

                  </Col>
                </Row>
                <p className='bold-text'>State</p>
                <p className='answer-text'>{fullState()}</p>

              </div>
              <div className="large-screen mx-5">
                <HelpSection />
              </div>
            </Col>
            <Col lg={6} className='margin-class'>
              <ThemeProvider theme={(theme) => createTheme({
                ...theme,
                ...InputTheme(),
              })}>
                <div className='mx-5'>
                  <h4 className="title mb-3">Select an appointment</h4>
                  <p className='para-text'>Your life insurance policy review will be completed over the phone with a licensed insurance specialist. During this appointment we will answer all of your questions and help you determine if your existing policy continues to meet all of your needs.</p>
                  <p className='para-text small-text'>Schedule an appointment at a convenient time or one of our insurance specialists will reach out to you within one business day.</p>
                  <Row>
                    <Col xs={6} className='pr-2'>
                      <Form.Group>
                        <TextInput
                          name="firstName"
                          id="firstName"
                          value={formState.firstName}
                          onChange={(e) => handleValueChange('firstName', e.target.value)}
                          label="First Name"
                          inputRef={register}
                          errors={errors.firstName}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={6} className='pl-2'>
                      <Form.Group>
                        <TextInput
                          name="lastName"
                          id="lastName"
                          value={formState.lastName}
                          onChange={(e) => handleValueChange('lastName', e.target.value)}
                          label="Last Name"
                          inputRef={register}
                          errors={errors.lastName}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group>
                    <TextInput
                      name="email"
                      id="email"
                      value={formState.email}
                      onChange={(e) => handleValueChange('email', e.target.value)}
                      label="Email"
                      inputRef={register}
                      errors={errors.email}
                    />
                  </Form.Group>
                  <Form.Group className="mb-1">
                    <TextInput
                      name="phone"
                      id="phone"
                      value={formState.phone}
                      onChange={(e) => handleValueChange('phone', e.target.value)}
                      label="Phone Number"
                      inputRef={register}
                      errors={errors.phone}
                      InputProps={{
                        inputComponent: InputMaskPhone,
                      }}
                    />
                  </Form.Group>
                </div>
                <Form.Group className='mb-0 mx-5'>
                  <RadioInput
                    name="specificAppt"
                    id="specificAppt"
                    label=""
                    value={formState.specificAppt}
                    radios={[{ value: "schedule", label: 'Schedule an appointment' }]}
                    onChange={e => handleValueChange('specificAppt', e.target.value)}
                    inputRef={register}
                  />
                </Form.Group>
                <Form.Group className='mx-5'>
                  <RadioInput
                    name="specificAppt"
                    id="specificAppt"
                    label=""
                    value={formState.specificAppt}
                    radios={[{ value: "asap", label: "Contact me within one business day" }]}
                    onChange={e => handleValueChange('specificAppt', e.target.value)}
                    errors={errors.specificAppt}
                    inputRef={register}
                  />
                </Form.Group>
              </ThemeProvider>

              <div className='mx-5'>
                <Scheduler
                  hide={formState.specificAppt !== 'schedule'}
                  hideBusinessHours={true}
                  register={register}
                  errors={errors}
                  timeZone={formState.timeZone}
                  apptDate={formState.specificApptDate}
                  apptTime={formState.specificApptTime}
                  setTimeZone={(e) => handleValueChange('timeZone', e)}
                  setApptDate={(e) => handleValueChange('specificApptDate', e)}
                  setApptTime={(e) => handleValueChange('specificApptTime', e)}
                />
                <BusinessHours />
                <BackNext onBack={() => props.history.push('/policy-review/existing-insurance')} continueLabel={{ text: 'Submit' }} loading={loading} />
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
    </HeaderStepper>
  )
}

Schedule.DefaultFormState = (prefill = false) => {
  return {
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    specificAppt: '',
    specificApptDate: '',
    specificApptTime: '',
    timeZone: ''
  }
};

Schedule.ValidationSchema = object().shape({
  email: string()
    .email('Email address must be valid.')
    .required('Email is required'),
  firstName: customValidators.string().isValidNameWithFiftyChar('First Name is required.', true).required('First Name is required.'),
  lastName: customValidators.string().isValidNameWithFiftyChar('Last Name is required.', true).required('Last Name is required.'),
  phone: string()
    .required('Phone number is required.')
    .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
  timeZone: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: string().required("Timezone is required."),
  }),
  specificAppt: string()
    .required('Select an appointment option.'),
  specificApptDate: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: string().required("Date is required."),
  }),
  specificApptTime: string()
    .when('specificAppt', {
      is: 'schedule',
      then: string().required('Time of call is required.'),
      otherwise: string().notRequired()
    }),
});



// WEBPACK FOOTER //
// ./src/components/PolicyReview/Schedule.js